module.exports = __webpack_public_path__ + "static/media/user.be72e3d1.svg";